/**
 * The two number shapes a reader sees in every reviews surface, and the anchor that links them.
 *
 * They lived inside `sections/product-reviews` until the `rating` block grew its own breakdown card
 * (16/09/2026): the same average, the same count, the same digits. Two copies of `Intl.NumberFormat`
 * would have drifted the day one of them was tweaked — an Arabic shop printing ١٥٣٥ above the fold and
 * 1,535 below it is exactly the kind of split nobody notices until a reader does.
 */
/**
 * WHERE THE "READ ALL REVIEWS" BUTTON LANDS.
 *
 * The `product-reviews` section wears this id, and anything that wants to send a reader to the reviews
 * links to `#aqx-reviews`. A plain anchor on purpose: it scrolls with scripts off, it survives an island
 * that has not hydrated yet, and it needs no engine to bind to. The section also carries a
 * `scroll-margin-block-start` so its title does not land under a sticky header.
 */
export const REVIEWS_ANCHOR_ID = 'aqx-reviews';
/** One decimal, in the reader's own convention — 4.9 in English, 4,9 in French. */
export function formatAverage(value, locale) {
    try {
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }).format(value);
    }
    catch {
        return value.toFixed(1);
    }
}
/** The reader's own digits and grouping — 1 527 in French, ١٥٢٧ in Arabic. */
export function formatCount(value, locale) {
    try {
        return new Intl.NumberFormat(locale).format(value);
    }
    catch {
        return String(value);
    }
}
//# sourceMappingURL=reviewFormat.js.map